import { render } from "./ExamesView.vue?vue&type=template&id=5c8db84e&scoped=true"
import script from "./ExamesView.vue?vue&type=script&lang=js"
export * from "./ExamesView.vue?vue&type=script&lang=js"

import "./ExamesView.vue?vue&type=style&index=0&id=5c8db84e&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8db84e"]])

export default __exports__